import { InferType } from 'yup'

import Yup from '@/lib/utils/yup'

export enum Fields {
  email = 'email',
}

export const forgotPasswordFormSchema = Yup.object({
  [Fields.email]: Yup.string().required(),
})

export const formName = 'ForgotPasswordForm'

export { Fields as ForgotPasswordFormFields }

export type ForgotPasswordFormSchemaType = InferType<
  typeof forgotPasswordFormSchema
>
